import mutations from './mutationCategory.js'
import actions from './actionCategory.js'

export default {
  state: {
    categories: {},
    category: {}
  },
  mutations,
  actions
}
